<template>
    <span>
        <template v-if="display_amount">{{format.format(display_amount)}}</template>
        <template v-else>...</template>

        {{display_symbol}}
    </span>
</template>

<script>
const currencyAliases = {
  EURO: 'EUR',
  EUROS: 'EUR',
  GPB: 'GBP'
};

function normalizeCurrency(symbol)
{
  const currency = String(symbol || '').trim().toUpperCase();

  return currencyAliases[currency] || currency;
}

export default {
  props: ['amount', 'symbol'],
  data: function ()
  {
    return {
      format: new Intl.NumberFormat('en-US'),
      display_amount: this.amount,
      display_symbol: normalizeCurrency(this.symbol)
    }
  },
  watch: {
    '$root.currency': function (symbol)
    {
      const fromCurrency = normalizeCurrency(this.symbol);
      const toCurrency = normalizeCurrency(symbol);

      this.display_amount = '';
      this.display_symbol = toCurrency;

      var requestURL = 'https://api.exchangerate.host/convert?from='+fromCurrency+'&to='+toCurrency+'&amount='+this.amount+'&access_key=39df21684d8b8c150c304603482c935b';
      var request = new XMLHttpRequest();
      request.open('GET', requestURL);
      request.responseType = 'json';
      request.send();

      request.onload = () =>
      {
        if(request.response && request.response.success !== false && request.response.result !== undefined) {
          this.display_amount = Math.round(request.response.result);
          return;
        }

        this.display_amount = this.amount;
        this.display_symbol = fromCurrency;
      }
    }
  }
}
</script>
